// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__142Xo","boxTitle":"Qualiphy_boxTitle__3OqGP","box":"Qualiphy_box__m_IYd","toggleWrap":"Qualiphy_toggleWrap__2gksl"};